export default __webpack_public_path__ + "static/soon-gift-en-be108a4e1af26976a628a63ff8bfd8a5.svg";